import React, { useMemo } from 'react';
import { Box, Tabs, Tab, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import CouponsManagement from './CouponsManagement';
import IssuedCoupons from './IssuedCoupons';

const TAB_KEYS = ['management', 'issued', 'used'];

const CouponsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [searchParams, setSearchParams] = useSearchParams();

  const tabIndex = useMemo(() => {
    const key = (searchParams.get('tab') || 'management').toLowerCase();
    const idx = TAB_KEYS.indexOf(key);
    return idx >= 0 ? idx : 0;
  }, [searchParams]);

  const handleTabChange = (_event, newValue) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', TAB_KEYS[newValue] || 'management');
    setSearchParams(next, { replace: true });
  };

  return (
    <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" component="h1" fontWeight="bold">
          Coupons
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Manage coupon templates, follow up on issued coupons, and review used coupons
        </Typography>
      </Box>

      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant={isMobile ? 'scrollable' : 'standard'}
        scrollButtons="auto"
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 2,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            minWidth: { xs: 120, sm: 160 },
          },
        }}
      >
        <Tab label="CRUD Management" />
        <Tab label="Issued Coupons" />
        <Tab label="Used Coupons" />
      </Tabs>

      {tabIndex === 0 && <CouponsManagement embedded />}
      {tabIndex === 1 && <IssuedCoupons variant="issued" embedded />}
      {tabIndex === 2 && <IssuedCoupons variant="used" embedded />}
    </Box>
  );
};

export default CouponsPage;
